import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, LinkedinIcon, MailIcon, YoutubeIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerSubscribe } from '../data/homepage';
import { DecorPanel } from './ui/DecorPanel';
import { PillButton } from './ui/PillButton';

/** Les deux colonnes de liens du pied de page réel de beaconsfield.ca. */
const columns: {
  label: string;
  to?: string;
  href?: string;
}[][] = [[{
  label: 'Actualités',
  to: '/notifications'
}, {
  label: 'Calendrier des collectes',
  to: '/mes-collectes'
}, {
  label: 'Carte interactive',
  to: '/plan'
}], [{
  label: 'Directive linguistique',
  href: '#accueil'
}, {
  label: 'Événements',
  to: '/'
}, {
  label: 'Nétiquette',
  href: '#accueil'
}]];
const socials = [{
  label: 'Facebook',
  icon: FacebookIcon,
  href: 'https://www.facebook.com/BeaconsfieldQuebec/'
}, {
  label: 'Instagram',
  icon: InstagramIcon,
  href: 'https://www.instagram.com/beaconsfield_qc/'
}, {
  label: 'YouTube',
  icon: YoutubeIcon,
  href: 'https://www.youtube.com/@evenementsvirtuelsbeaconsf3672'
}, {
  label: 'LinkedIn',
  icon: LinkedinIcon,
  href: 'https://ca.linkedin.com/company/beaconsfieldqc'
}];
export function Footer() {
  return <footer data-id="element-1613" data-mp="3v916dfu99b2e">
      {/* Bande 1 — abonnements */}
      <DecorPanel tone="navy" curve={{
      variant: 'wave',
      placement: 'top-left',
      className: 'h-full w-1/3'
    }} className="w-full" data-id="element-1614" data-mp="3q83q58st2r3j">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-6 px-5 py-10 lg:px-10" data-id="element-1615" data-mp="80ns6fvjmkba">
          <div data-id="element-1616" data-mp="hsk3wtqjy8xz">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-white/70" data-id="element-1617" data-mp="htd4fcyx427o">
              {footerSubscribe.eyebrow}
            </p>
            <h2 className="mt-2 max-w-xl font-display text-2xl font-extrabold uppercase leading-[1.05] tracking-tight text-white lg:text-3xl" data-id="element-1618" data-mp="cuijo5he43kx">
              {footerSubscribe.title}
            </h2>
          </div>
          <PillButton to={footerSubscribe.cta.to} variant="orange" data-id="element-1619" data-mp="mpts6627gek8">
            {footerSubscribe.cta.label}
          </PillButton>
        </div>
      </DecorPanel>

      {/* Bande 2 — pied de page principal */}
      <div className="bg-ville-blue text-white" data-id="element-1620" data-mp="yrv4arsve3rh">
        <div className="mx-auto max-w-[1400px] px-5 py-12 lg:px-10" data-id="element-1621" data-mp="13sipuxybxseb">
          <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)_minmax(0,1fr)]" data-id="element-1622" data-mp="18kiw184zthjc">
            <div data-id="element-1623" data-mp="1cm43uf2o75mo">
              <Logo variant="light" data-id="element-1624" data-mp="1ckkocqou8yly" />
              <p className="mt-8 text-sm text-white/80" data-id="element-1625" data-mp="1cnozy94muwmn">© Ville de Beaconsfield, 2026</p>
              <a href="#accueil" className="mt-1 block text-sm text-white/80 hover:text-white" data-id="element-1626" data-mp="1hiujx2eh6183">
                Politique de confidentialité
              </a>
              <a href="https://www.blanko.ca/fr" className="mt-1 block text-sm font-bold text-white hover:underline" data-id="element-1627" data-mp="1rj4yorg5rgpd">
                Blanko
              </a>
            </div>

            <div className="grid gap-8 sm:grid-cols-2 lg:border-x lg:border-white/20 lg:px-10" data-id="element-1628" data-mp="3ta86l8ynyh68">
              {columns.map((column, index) => <nav key={index} aria-label={`Liens du pied de page ${index + 1}`} data-id="element-1629" data-mp="2afx1uxtgg54x" data-mpi={index}>
                  <ul className="space-y-3" data-id="element-1630" data-mp="25ncas41xo653">
                    {column.map(link => <li key={link.label} data-id="element-1631" data-mp="21m0kdwb8jgvu">
                        {link.href ? <a href={link.href} className="text-xs font-bold uppercase tracking-wider text-white transition-colors duration-150 ease-ville hover:text-ville-lime" data-id="element-1632" data-mp="1wo8qwxuxzmpj">
                            {link.label}
                          </a> : <Link to={link.to ?? '/'} className="text-xs font-bold uppercase tracking-wider text-white transition-colors duration-150 ease-ville hover:text-ville-lime" data-id="element-1633" data-mp="2kfe4f6deu2wo">
                            {link.label}
                          </Link>}
                      </li>)}
                  </ul>
                </nav>)}
            </div>

            <div data-id="element-1634" data-mp="2wnr30v8bsv64">
              <h2 className="font-display text-xl font-bold uppercase leading-tight tracking-tight text-white" data-id="element-1635" data-mp="2woanojpd1xnu">
                Vous avez des questions ou voulez communiquer avec nous&nbsp;?
              </h2>
              <PillButton href="#accueil" variant="white" icon={MailIcon} className="mt-6" data-id="element-1636" data-mp="3bjqi4pturvkr">
                Nous joindre
              </PillButton>

              <address className="mt-6 space-y-1 text-sm not-italic text-white/80" data-id="element-1637" data-mp="3fk0rmcgut44d">
                <p data-id="element-1638" data-mp="31khibgcb3mqh">303, boulevard Beaconsfield, Beaconsfield (Québec) H9W 4A7</p>
                <p data-id="element-1639" data-mp="36k44wge0yfby">
                  <a href="tel:5144284400" className="hover:text-white" data-id="element-1640" data-mp="36jkpp7fre51m">
                    514 428-4400
                  </a>
                  {' · '}
                  <span className="text-white/60" data-id="element-1641" data-mp="1v5gujxxfqauz">Urgences après heures&nbsp;:</span>{' '}
                  <a href="tel:5144285999" className="hover:text-white" data-id="element-1642" data-mp="1v344sylfqw7d">
                    514 428-5999
                  </a>
                </p>
              </address>
            </div>
          </div>

          <ul className="mt-10 flex items-center gap-2 border-t border-white/20 pt-8" data-id="element-1643" data-mp="1ip7cdm0p2vb4">
            {socials.map(social => <li key={social.label} data-id="element-1644" data-mp="1rn1c76xo4731">
                <a href={social.href} aria-label={`Suivre la Ville de Beaconsfield sur ${social.label}`} className="grid h-10 w-10 place-items-center rounded-full border border-white/40 transition-colors duration-150 ease-ville hover:bg-white hover:text-ville-blue" data-id="element-1645" data-mp="1ro2kx4r7ohhl">
                  <social.icon className="h-4 w-4" aria-hidden="true" data-id="element-1646" data-mp="18x1purt7p63b" />
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}